import { render, staticRenderFns } from "./SaleDocumentsContractCollapse.vue?vue&type=template&id=3fa768e2&scoped=true&"
import script from "./SaleDocumentsContractCollapse.vue?vue&type=script&lang=js&"
export * from "./SaleDocumentsContractCollapse.vue?vue&type=script&lang=js&"
import style0 from "./SaleDocumentsContractCollapse.vue?vue&type=style&index=0&id=3fa768e2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa768e2",
  null
  
)

export default component.exports